import React, { useState, useEffect } from "react";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { Dialog } from "primereact/dialog";
import { obtenerSocios, setListadoSocios } from "../../sliceRedux/ValidarReserva.slice";
import { useSelector } from "react-redux";
import { nemonicoSistema } from "../../constantes/appConstantes";

const ModalSocios = (props) => {
  const {
    modal,
    callbackModal,
    showLoader,
    hideLoader,
    dispatch,
    codSolConstitucion,
    callbackSelected,
    selectedSocios,
  } = props;
  const [globalFilter, setGlobalFilter] = useState("");
  const [bandejaSocios, setBandejaSocios] = useState([]);
  const listadoSocios = useSelector((state) => state.validar.listadoSocios);

  useEffect(() => {
    showLoader();
    dispatch(obtenerSocios(codSolConstitucion));
  }, []);

  useEffect(() => {
    if (listadoSocios.code === 200) {
      let listado = listadoSocios?.object?.listSocios ?? [];
      listado = listado.filter(
        (item) =>
          item.nemCargo !== nemonicoSistema.CARGO_REPRESENTANTE_LEGAL &&
          !selectedSocios.includes(item.codSolConstSocios)
      );
      setBandejaSocios(listado);
    }

    return () => {
      hideLoader();
      dispatch(setListadoSocios({ ...listadoSocios, ...{ code: 0 } }));
    };
  }, [listadoSocios.code]);

  const renderHeader = (
    <div className="flex justify-content-between">
      <div></div>
      <div>
        <IconField iconPosition="left">
          <InputIcon className="pi pi-search" />
          <InputText value={globalFilter} onChange={(e) => buscar(e)} placeholder="Buscar..." />
        </IconField>
      </div>
    </div>
  );

  const buscar = (e) => {
    const value = e.target.value;
    setGlobalFilter(value);

    let listado = listadoSocios?.object?.listSocios ?? [];
    listado = listado.filter(
      (item) =>
        item.nemCargo !== nemonicoSistema.CARGO_REPRESENTANTE_LEGAL &&
        !selectedSocios.includes(item.codSolConstSocios)
    );

    if (value === "") {
      setBandejaSocios(listado);
      return;
    }

    const filtro = listado?.filter((item) => {
      return (
        item.nomCatTipoIdentificacion?.toUpperCase().includes(value.toUpperCase()) ||
        item.numIdentificacion?.toUpperCase().includes(value.toUpperCase()) ||
        item.nombres?.toUpperCase().includes(value.toUpperCase())
      );
    });

    setBandejaSocios(filtro);
  };

  const rowIndexTemplate = (rowData, column) => {
    return column.rowIndex + 1 + "";
  };

  const actionTemplate = (rowData) => {
    return (
      <>
        <Button
          icon="pi pi-check-square"
          rounded
          label="Seleccionar"
          onClick={() => callbackSelected(rowData)}
        />
      </>
    );
  };

  const renderFooterAC = (stateMethod) => {
    return (
      <div className="flex justify-content-center">
        <Button
          label="Cancelar"
          icon="pi pi-times-circle"
          onClick={callbackModal}
          severity="info"
        />
      </div>
    );
  };

  return (
    <Dialog
      visible={modal}
      header="Seleccionar socio"
      modal
      onHide={callbackModal}
      footer={renderFooterAC(null)}
    >
      <DataTable
        header={renderHeader}
        className="p-datatable-responsive-demo"
        paginator
        rows={10}
        dataKey="codSolConstSocios"
        loading={undefined}
        value={bandejaSocios}
        emptyMessage="Sin registros que mostrar."
        columnResizeMode="fit"
        style={{ width: "100%", overflow: "auto!important" }}
      >
        <Column
          body={rowIndexTemplate}
          header="Nro."
          sortable
          sortField="codSolConstSocios"
          headerStyle={{ textAlign: "center" }}
          style={{ width: "3%" }}
          bodyStyle={{
            textAlign: "center",
          }}
        />
        <Column
          field="nomCatTipoIdentificacion"
          header="Tipo de identificación"
          sortable
          headerStyle={{ textAlign: "center" }}
        />
        <Column
          field="numIdentificacion"
          header="Identificación"
          sortable
          headerStyle={{ textAlign: "center" }}
        />
        <Column
          field="nombres"
          header="Apellidos y nombres"
          sortable
          headerStyle={{ textAlign: "center" }}
        />
        <Column
          header="Acciones"
          headerStyle={{ textAlign: "center" }}
          bodyStyle={{
            textAlign: "center",
          }}
          body={actionTemplate}
        ></Column>
      </DataTable>
    </Dialog>
  );
};
export default ModalSocios;
